import { Table } from "@/features/Table";
import { type GroupUser, group_users_columns } from "./columns";
import { type FilterGroupUsersSchema, FilterGroupUsers } from "./filter";
import { useLocation } from "react-router-dom";

const client = "admin-quantilia";
const table_name = "group_users";

export const GroupUsersTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<GroupUser, FilterGroupUsersSchema>
      label="User Groups"
      client={client}
      table_name={table_name}
      columns={group_users_columns}
      filter={<FilterGroupUsers />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
